import { Div } from '../../../../base/components/native/div'
import { Logo } from '../logo'

export const Footer = () => {

    const base = Div()
    const socials = Div('Twitter  |  Pinterest  |  Instagram  |  Youtube')
    const co = Div('© 2023 HelloPrint ')
    const logo = Logo()
    co.prepend(logo)
    base.append(co, socials)

    logo.cssClass({
        marginRight: '40px'
    })
    socials.cssClass({
        marginTop: '30px',
        opacity: '0.7',
    })
    co.cssClass({
        width: '340px',
        color: '#969696',
        display: 'flex',
        alignItems: 'end'
    })
    base.cssClass({
        fontSize: '18px',
        display: 'flex',
        justifyContent: 'space-between',
        color: '#fff',
        backgroundColor: '#000',
        padding: '40px 60px',
        '@media (max-width: 768px)': {
            flexDirection: 'column',
            alignItems: 'center',
            padding: '30px',
        }
    })

    return base
}